import Service from "../Service";
import Vue from "vue";
const resource = "AreaWeather/";

export default {
  pagination(parameters, requestID) {
    // console.log('Pafination', parameters, requestID);
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(advanceProducer, requestID) {
    return Service.post(resource + "save", advanceProducer, {
      params: { requestID },
    });
  },
  getWeatherExternal(latitude, longitude, requestID) {
    return Service.post(resource + "getWeatherExternal", {}, {
      params: { latitude, longitude, requestID },
    });
  },

};
